import { useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { LabourUnitsResult } from 'modules/timeoff/hooks/useLabourUnits'
import type LeaveForm from 'modules/timeoff/lib/LeaveForm'

import type { Role } from './useCurrentEmployeeRole'

interface ReturnType {
  button: string
  tooltip: string | null | undefined
  tooltipOpen: boolean
  toggleTooltip: (value: boolean) => () => void
}

interface Props {
  form: LeaveForm
  isCurrentEmployee: boolean
  currentEmployeeRole: Role
  labourUnits: LabourUnitsResult
  showSelectEmployee?: boolean
}

const selectButtonLabel = ({ form, labourUnits, showSelectEmployee = false }: Props): string => {
  if (showSelectEmployee) {
    return i18n.t('time_off.submit_no_employee')
  }
  if (form.isSickType()) {
    return i18n.t('time_off.medical.request')
  }
  if (form.isParentalType()) {
    return i18n.t('time_off.submit_parental_leave')
  }
  if (labourUnits.value === 0 || labourUnits.enableFrenchCalendarFlag) {
    return i18n.t('time_off.submit.generic')
  }
  return i18n.t('common.submit')
}

const useButtonCopy = (props: Props): ReturnType => {
  const [tooltipOpen, toggleTooltip] = useToggle(false)
  const button = selectButtonLabel(props)

  const tooltipCopy = props.isCurrentEmployee
    ? i18n.t('time_off.natural_days_button_tooltip_me')
    : i18n.t('time_off.natural_days_button_tooltip')

  const tooltip =
    props.form.isComputingNaturalDays() && props.form.isRegularCalendarDays() ? tooltipCopy : null

  return {
    button,
    tooltip,
    tooltipOpen,
    toggleTooltip,
  }
}

export default useButtonCopy
